import {
  BinaryColumnPredicateOp,
  FilterCellBinaryColumnPredicateOp,
  FilterCellColumnPredicateOp,
  FilterCellListBinaryColumnPredicateOp,
  FilterCellLumpColumnPredicateOp,
  FilterCellUnaryColumnPredicateOp,
  FilterType,
  ListBinaryColumnPredicateOp,
  LumpColumnPredicateOp,
  UnaryColumnPredicateOp,
} from "@hex/common";

export const GROUPED_FILTER_PREDICATE_OPS: Record<
  string,
  FilterCellColumnPredicateOp[]
> = {
  All: [
    FilterCellListBinaryColumnPredicateOp.IS_ONE_OF,
    FilterCellListBinaryColumnPredicateOp.NOT_ONE_OF,
    BinaryColumnPredicateOp.EQ,
    BinaryColumnPredicateOp.NEQ,
    UnaryColumnPredicateOp.ALWAYS,
    UnaryColumnPredicateOp.NOT_NULL,
    UnaryColumnPredicateOp.IS_NULL,
  ],
  Text: [
    BinaryColumnPredicateOp.CONTAINS,
    BinaryColumnPredicateOp.NOT_CONTAINS,
    FilterCellUnaryColumnPredicateOp.IS_EMPTY,
    FilterCellUnaryColumnPredicateOp.NOT_EMPTY,
  ],
  Number: [
    BinaryColumnPredicateOp.GT,
    BinaryColumnPredicateOp.GTE,
    BinaryColumnPredicateOp.LT,
    BinaryColumnPredicateOp.LTE,
  ],
  Date: [
    BinaryColumnPredicateOp.DATE_AFTER,
    BinaryColumnPredicateOp.DATE_BEFORE,
    FilterCellBinaryColumnPredicateOp.DATE_EQUAL_OR_AFTER,
    FilterCellBinaryColumnPredicateOp.DATE_EQUAL_OR_BEFORE,
    ListBinaryColumnPredicateOp.DATE_BETWEEN,
    BinaryColumnPredicateOp.DATE_NOT_EQUAL,
    BinaryColumnPredicateOp.DATE_EQUAL,
  ],
  Boolean: [UnaryColumnPredicateOp.IS_TRUE, UnaryColumnPredicateOp.IS_FALSE],
  Lump: [
    LumpColumnPredicateOp.TOP_N,
    LumpColumnPredicateOp.BOTTOM_N,
    LumpColumnPredicateOp.NOT_TOP_N,
    LumpColumnPredicateOp.NOT_BOTTOM_N,
  ],
};

export const FILTER_TYPE_TO_LABEL: Record<FilterType, string> = {
  [FilterType.KEEP]: "Keep rows",
  [FilterType.REMOVE]: "Remove rows",
};

export const FILTER_OP_TO_LABEL: Record<FilterCellColumnPredicateOp, string> = {
  [UnaryColumnPredicateOp.ALWAYS]: "Always",
  [BinaryColumnPredicateOp.EQ]: "Is equal to",
  [BinaryColumnPredicateOp.NEQ]: "Is not equal to",
  [BinaryColumnPredicateOp.CONTAINS]: "Text contains",
  [BinaryColumnPredicateOp.NOT_CONTAINS]: "Text does not contain",
  [UnaryColumnPredicateOp.IS_FALSE]: "Is false",
  [UnaryColumnPredicateOp.IS_TRUE]: "Is true",
  [BinaryColumnPredicateOp.DATE_EQUAL]: "Is on",
  [BinaryColumnPredicateOp.DATE_NOT_EQUAL]: "Is not on",
  [BinaryColumnPredicateOp.DATE_BEFORE]: "Is before",
  [BinaryColumnPredicateOp.DATE_AFTER]: "Is after",
  [ListBinaryColumnPredicateOp.DATE_BETWEEN]: "Is between",
  [BinaryColumnPredicateOp.GT]: "Greater than",
  [BinaryColumnPredicateOp.GTE]: "Greater than or equal to",
  [BinaryColumnPredicateOp.LT]: "Less than",
  [BinaryColumnPredicateOp.LTE]: "Less than or equal to",
  [UnaryColumnPredicateOp.IS_NULL]: "Is null",
  [UnaryColumnPredicateOp.NOT_NULL]: "Is not null",
  [FilterCellUnaryColumnPredicateOp.IS_EMPTY]: "Is empty",
  [FilterCellUnaryColumnPredicateOp.NOT_EMPTY]: "Is not empty",
  [FilterCellListBinaryColumnPredicateOp.IS_ONE_OF]: "Is one of",
  [FilterCellListBinaryColumnPredicateOp.NOT_ONE_OF]: "Is not one of",
  [FilterCellBinaryColumnPredicateOp.DATE_EQUAL_OR_AFTER]: "Is on or after",
  [FilterCellBinaryColumnPredicateOp.DATE_EQUAL_OR_BEFORE]: "Is on or before",
  [FilterCellLumpColumnPredicateOp.TOP_N]: "Is in top",
  [FilterCellLumpColumnPredicateOp.BOTTOM_N]: "Is in bottom",
  [FilterCellLumpColumnPredicateOp.NOT_TOP_N]: "Is not in top",
  [FilterCellLumpColumnPredicateOp.NOT_BOTTOM_N]: "Is not in bottom",
};

export const FILTER_OP_TO_INPUT_TYPE: Partial<
  Record<FilterCellColumnPredicateOp, string>
> = {
  [BinaryColumnPredicateOp.DATE_AFTER]: "date",
  [BinaryColumnPredicateOp.DATE_BEFORE]: "date",
  [BinaryColumnPredicateOp.DATE_EQUAL]: "date",
};
